{
  "actions": {
    "apply": "Apply",
    "cancel": "Cancel",
    "clear": "Clear",
    "close": "Close",
    "confirm": "Confirm",
    "delete": "Delete",
    "done": "Done",
    "edit": "Edit",
    "more": "More",
    "remove": "Remove",
    "retry": "Try again",
    "save": "Save"
  },
  "states": {
    "loading": "Loading…",
    "saving": "Saving…"
  },
  "time": {
    "justNow": "just now"
  },
  "validation": {
    "required": "This field is required"
  },
  "errors": {
    "aborted": "The request was cancelled",
    "badRequest": "The request could not be processed. Check the data and try again.",
    "conflict": "The data changed while you were editing it. Refresh the page and try again.",
    "forbidden": "You don't have access to this section.",
    "forbiddenTitle": "No access",
    "gone": "This is no longer available.",
    "network": "Can't reach the server. Check your internet connection.",
    "notFound": "The item was not found or has been deleted.",
    "rateLimited": "Too many requests. Please wait a moment and try again.",
    "renderFailed": "Couldn't display this content",
    "renderFailedHint": "Close the panel and try opening it again.",
    "server": "Something went wrong on the server. Please try again a bit later.",
    "tooLarge": "The file is too large.",
    "unauthorized": "Your session has expired. Please sign in again.",
    "unknown": "Something went wrong",
    "validation": "Please check the highlighted fields.",
    "adminNetwork": "You are an administrator, but not from this network: the administrator role works only from the allowed networks (Administration → Sign-in security). Connect from the office or over the VPN."
  },
  "fileErrors": {
    "invalid_multipart": "The upload was interrupted or is damaged. Try again.",
    "invalid_thumbnail_size": "This preview size is not available.",
    "multipart_required": "The file could not be sent. Try again.",
    "no_file": "Choose a file to upload.",
    "not_found": "The file was not found or has been deleted.",
    "scan_pending": "The file is still being checked for viruses. Try again in a minute.",
    "signature_expired": "The file link has expired. Refresh the page.",
    "signature_invalid": "The file link is not valid.",
    "signature_missing": "The file link is incomplete.",
    "thumbnail_not_ready": "The preview is not ready yet.",
    "too_large": "The file is too large.",
    "quota_exceeded": "You uploaded too much in a day. Try again later.",
    "upload_pending_limit": "Too many unfinished uploads. Finish or cancel some of them.",
    "upload_expired": "The upload has expired. Start it again.",
    "upload_not_found": "The upload was not found. Start it again.",
    "upload_chunk_invalid": "A part of the file is damaged. Upload the file again.",
    "upload_size_invalid": "An empty file cannot be uploaded in parts."
  },
  "session": {
    "unreachableTitle": "Server unavailable",
    "unreachableHint": "Couldn't connect to Orbita. Check your connection and try again."
  },
  "avatarStack": {
    "label_one": "{{count}} member",
    "label_other": "{{count}} members",
    "andMore_one": "and {{count}} more",
    "andMore_other": "and {{count}} more"
  },
  "pickers": {
    "choosePerson": "Choose a person",
    "choosePeople": "Choose people",
    "chooseGroup": "Choose a group",
    "chooseGroups": "Choose groups",
    "chooseDepartment": "Choose a department",
    "chooseDepartments": "Choose departments",
    "searchPeople": "Search people…",
    "searchGroups": "Search groups and projects…",
    "searchDepartments": "Search departments…",
    "noPeople": "No one found",
    "noGroups": "No groups found",
    "noDepartments": "No departments found",
    "people": "People",
    "group": "Group",
    "project": "Project",
    "members_one": "{{count}} member",
    "members_other": "{{count}} members",
    "loadError": "Couldn't load the list"
  },
  "audience": {
    "everyone": "All employees",
    "add": "Add",
    "choose": "Choose recipients",
    "tabs": {
      "users": "People",
      "departments": "Departments",
      "groups": "Groups"
    }
  },
  "date": {
    "pickDate": "Pick a date",
    "pickDateTime": "Pick date and time",
    "pickRange": "Pick a period",
    "time": "Time",
    "today": "Today",
    "presets": {
      "today": "Today",
      "yesterday": "Yesterday",
      "thisWeek": "This week",
      "last7Days": "Last 7 days",
      "thisMonth": "This month",
      "last30Days": "Last 30 days",
      "thisYear": "This year"
    }
  },
  "table": {
    "columns": "Columns",
    "toggleColumns": "Visible columns",
    "empty": "No data",
    "sortBy": "Sort by “{{column}}”",
    "range": "{{from}}–{{to}} of {{total}}",
    "selected_one": "{{count}} row selected",
    "selected_other": "{{count}} rows selected",
    "rowsPerPage": "Rows per page",
    "page": "Page {{page}} of {{pages}}",
    "firstPage": "First page",
    "previousPage": "Previous page",
    "nextPage": "Next page",
    "lastPage": "Last page",
    "selectAll": "Select all rows",
    "selectRow": "Select row"
  },
  "files": {
    "attach": "Attach",
    "browse": "Choose files",
    "orDrop": "or drag them here",
    "dropzoneLabel": "Upload files",
    "maxSize": "Up to {{max}} per file",
    "tooLarge": "“{{name}}” is larger than {{max}}",
    "notAccepted": "“{{name}}” is not a supported file type here",
    "tooMany_one": "You can attach at most {{count}} file",
    "tooMany_other": "You can attach at most {{count}} files",
    "failed": "Failed",
    "cancelUpload": "Cancel upload",
    "scanPending": "Checking for viruses…",
    "scanClean": "Checked",
    "scanInfected": "Virus found, the file was removed",
    "retrying": "Connection lost, retry {{attempt}}…",
    "offline": "No network — the upload continues by itself",
    "resumed": "Continuing: {{size}} are already on the server",
    "download": "Download",
    "openInNewTab": "Open in a new tab",
    "preview": "Preview “{{name}}”",
    "previewFailed": "Couldn't load the preview.",
    "noPreview": "There's no preview for this file type.",
    "previous": "Previous file",
    "next": "Next file",
    "remove": "Remove “{{name}}”"
  },
  "richText": {
    "placeholder": "Write something…",
    "toolbar": "Formatting",
    "undo": "Undo",
    "redo": "Redo",
    "textStyle": "Text style",
    "paragraph": "Normal text",
    "heading": "Heading {{level}}",
    "bold": "Bold",
    "italic": "Italic",
    "underline": "Underline",
    "strike": "Strikethrough",
    "code": "Code",
    "link": "Link",
    "linkUrl": "Link address",
    "invalidUrl": "Enter a valid address, e.g. https://example.com",
    "removeLink": "Remove link",
    "bulletList": "Bulleted list",
    "orderedList": "Numbered list",
    "taskList": "Checklist",
    "quote": "Quote",
    "codeBlock": "Code block",
    "divider": "Divider",
    "callout": "Callout",
    "callouts": {
      "info": "Note",
      "tip": "Tip",
      "warning": "Warning",
      "danger": "Important"
    },
    "removeCallout": "Remove callout",
    "mention": "Mention someone",
    "mentionPeople": "Mention a person",
    "image": "Image",
    "uploadingImage": "Uploading “{{name}}”…",
    "imageUploaded": "Image added",
    "table": "Table",
    "insertTable": "Insert table",
    "addRow": "Add row",
    "addColumn": "Add column",
    "toggleHeader": "Header row",
    "deleteRow": "Delete row",
    "deleteColumn": "Delete column",
    "deleteTable": "Delete table",
    "dropImagesOnly": "Only images can be inserted into the text. Attach other files instead."
  },
  "comments": {
    "title": "Comments",
    "placeholder": "Write a comment…",
    "send": "Send",
    "showEarlier": "Show earlier comments",
    "empty": "No comments yet",
    "emptyHint": "Be the first to start the conversation.",
    "loadError": "Couldn't load comments",
    "edited": "edited",
    "you": "you",
    "deleteTitle": "Delete this comment?",
    "deleteDescription": "The comment will be deleted permanently."
  },
  "reactions": {
    "add": "Add reaction",
    "whoReacted": "Who reacted",
    "toggle_one": "{{reaction}}: {{count}} reaction",
    "toggle_other": "{{reaction}}: {{count}} reactions",
    "like": "Like",
    "love": "Love",
    "laugh": "Haha",
    "wow": "Wow",
    "sad": "Sad",
    "angry": "Angry"
  },
  "kanban": {
    "empty": "Drop a card here",
    "instructions": "To pick up a card, press Space. Use the arrow keys to move it, Space or Enter to drop, Escape to cancel. Enter opens the card.",
    "pickedUp": "Picked up card {{id}}",
    "over": "Over column “{{column}}”",
    "dropped": "Card moved to column “{{column}}”",
    "cancelled": "Move cancelled",
    "scrollLeft": "Scroll left",
    "scrollRight": "Scroll right"
  },
  "sidePanel": {
    "title": "Panel",
    "copyLink": "Copy link",
    "linkCopied": "Link copied",
    "unavailable": "Panel unavailable",
    "unknownType": "The module that opens “{{type}}” panels is not installed."
  },
  "inlineEdit": {
    "empty": "Not set"
  },
  "placeholder": {
    "badge": "Soon",
    "title": "Coming soon",
    "description": "The team is already building this module. Navigation and the portal shell are ready — the capabilities below arrive in upcoming releases."
  },
  "messengerTabs": {
    "label": "Messenger sections"
  },
  "security": {
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "actions": {
      "cancel": "Cancel",
      "done": "Done"
    },
    "setup": {
      "title": "Turn on two-factor authentication",
      "description": "After the password, sign-in will ask for a code from an app on your phone.",
      "steps": "Steps",
      "step": {
        "password": "Password",
        "scan": "App",
        "codes": "Recovery codes"
      },
      "passwordHint": "Enter your password to continue.",
      "password": "Your password",
      "scanHint": "Scan the QR code with an authenticator app (Google Authenticator, Microsoft Authenticator, 2FAS, Aegis…), then enter the 6-digit code it shows.",
      "qrAlt": "QR code for the authenticator app",
      "manualKey": "Cannot scan? Enter this key",
      "copyKey": "Copy the key",
      "manualHint": "Time-based code (TOTP), 6 digits, 30 seconds.",
      "code": "6-digit code",
      "enabled": "Two-factor authentication is on.",
      "saved": "I saved the recovery codes in a safe place",
      "next": "Continue",
      "confirm": "Turn on",
      "done": "Finish"
    },
    "recovery": {
      "title": "Recovery codes",
      "warning": "Save these codes now: they are shown only once. Each one signs you in once if you lose the phone.",
      "fileHeading": "Orbita recovery codes (each works once)",
      "copy": "Copy",
      "copied": "Copied",
      "download": "Download",
      "print": "Print"
    },
    "twoFactor": {
      "title": "Two-factor authentication",
      "description": "A code from an app on your phone in addition to the password protects the account even if the password leaks.",
      "on": "On",
      "off": "Off",
      "graceUntil": "The administrator requires two-factor authentication. Turn it on by {{date}}, otherwise sign-in will ask for it first.",
      "since": "On since {{date}}.",
      "codesLeft_one": "{{count}} recovery code left.",
      "codesLeft_other": "{{count}} recovery codes left.",
      "fewCodes": "Few recovery codes left. Create new ones before they run out.",
      "requiredNote": "The administrator requires two-factor authentication, so it cannot be turned off.",
      "newCodes": "New recovery codes",
      "turnOff": "Turn off",
      "turnOn": "Turn on",
      "disabled": "Two-factor authentication is off."
    },
    "disable": {
      "title": "Turn off two-factor authentication",
      "description": "Confirm with your password and a code from the app (or a recovery code).",
      "submit": "Turn off"
    },
    "regenerate": {
      "title": "New recovery codes",
      "description": "The old codes stop working. Confirm with your password and a code from the app.",
      "submit": "Create codes",
      "done": "Save the new codes. The old ones no longer work."
    },
    "reauth": {
      "password": "Password",
      "code": "Code",
      "codePlaceholder": "123 456",
      "codeHint": "A 6-digit code from the app or a recovery code."
    },
    "sessions": {
      "title": "Devices and sessions",
      "description": "Where you are signed in. Sign out of anything you do not recognize.",
      "empty": "No active sessions.",
      "loadError": "Could not load the sessions.",
      "current": "This device",
      "lastActive": "active {{when}}",
      "signedIn": "signed in {{when}}",
      "signOut": "Sign out",
      "signOutOthers": "Sign out everywhere else",
      "confirmTitle": "Sign out “{{device}}”?",
      "confirmText": "The device will have to sign in again. Pages already open there stop receiving updates at once.",
      "confirmAllTitle": "Sign out everywhere else?",
      "confirmAllText": "Every other device will have to sign in again. This device stays signed in.",
      "signedOut": "Signed out.",
      "signedOutMany_one": "{{count}} session signed out.",
      "signedOutMany_other": "{{count}} sessions signed out."
    },
    "rules": {
      "title": "Password requirements",
      "length": "Minimum length: {{n}}",
      "distinct": "At least {{n}} different characters",
      "mixedCase": "A lower-case and an upper-case letter",
      "digit": "A digit",
      "symbol": "A symbol (not a letter or digit)",
      "common": "Not one of the most common passwords",
      "history": "Different from your previous passwords (the last {{n}} are remembered)"
    },
    "reasons": {
      "too_short": "The password is too short: at least {{n}} characters.",
      "few_distinct": "Use at least 4 different characters.",
      "needs_mixed_case": "Use a lower-case and an upper-case letter.",
      "needs_digit": "Add a digit.",
      "needs_symbol": "Add a symbol.",
      "common": "This is one of the most common passwords.",
      "reused": "You used this password recently (the last {{n}} are remembered).",
      "other": "The password does not meet the requirements."
    },
    "restricted": {
      "signOut": "Sign out",
      "twoFactorTitle": "Set up two-factor authentication",
      "twoFactorText": "The administrator requires two-factor authentication for your account. Set it up to continue: it takes a minute and an authenticator app on your phone.",
      "passwordTitle": "Your password has expired",
      "passwordText": "The administrator limits how long a password may be used. Choose a new one to continue."
    },
    "password": {
      "current": "Current password",
      "new": "New password",
      "confirm": "Repeat the new password",
      "mismatch": "The passwords do not match",
      "submit": "Change password"
    }
  },
  "truncation": {
    "showing": "Showing {{shown}} of {{total}}"
  },
  "roles": {
    "builtIn": {
      "admin": {
        "title": "Administrator",
        "description": "Every permission, always. Not editable."
      },
      "user": {
        "title": "Employee",
        "description": "Every employee; gives no administrative permissions."
      },
      "hr": {
        "title": "HR",
        "description": "Deactivates employees and hands their work over; more permissions can be added."
      },
      "integrator": {
        "title": "Integrator",
        "description": "Connects the portal to other systems: webhooks, process settings, the search index, the operations pages."
      },
      "auditor": {
        "title": "Auditor",
        "description": "Reads the audit log and the operations pages; changes nothing."
      }
    }
  },
  "menuEditor": {
    "sections": {
      "primary": "Quick access",
      "main": "Menu",
      "admin": "Administration"
    },
    "drag": "Drag to reorder: {{label}}",
    "moveUp": "Move up: {{label}}",
    "moveDown": "Move down: {{label}}",
    "hide": "Hide: {{label}}",
    "show": "Show: {{label}}",
    "hiddenBadge": "Hidden"
  },
  "history": {
    "off": "Change history is switched off by the administrator",
    "empty": "No changes yet",
    "emptyHint": "Edits of the fields show up here: who changed what, and when.",
    "more": "Show more",
    "empty_value": "empty",
    "yes": "yes",
    "no": "no",
    "showMore": "more",
    "less": "less",
    "actor": {
      "unknown": "Unknown author",
      "process": "Business process",
      "robot": "Robot",
      "trigger": "Trigger",
      "system": "System"
    },
    "kind": {
      "process": "process",
      "robot": "robot",
      "trigger": "trigger",
      "system": "system",
      "api-token": "API token"
    },
    "fields": {
      "title": "Title",
      "status": "Status / stage",
      "category": "Pipeline",
      "responsible": "Responsible",
      "observers": "Observers",
      "description": "Description",
      "firstName": "First name",
      "lastName": "Last name",
      "secondName": "Middle name",
      "companyTitle": "Company name",
      "position": "Position",
      "phones": "Phones",
      "emails": "E-mail",
      "websites": "Websites",
      "address": "Address",
      "source": "Source",
      "sourceDescription": "Source details",
      "amount": "Amount",
      "probability": "Probability",
      "expectedCloseDate": "Expected close date",
      "companyId": "Company",
      "contactId": "Contact",
      "dealId": "Deal",
      "leadId": "Lead",
      "quoteId": "Quote",
      "contacts": "Contacts",
      "companies": "Companies",
      "lossReason": "Loss reason",
      "lossComment": "Loss comment",
      "closedAt": "Closed",
      "birthday": "Birthday",
      "type": "Type",
      "industry": "Industry",
      "employees": "Employees",
      "revenue": "Annual revenue",
      "number": "Number",
      "issueDate": "Issue date",
      "validUntil": "Valid until",
      "dueDate": "Due date",
      "paidAt": "Paid",
      "terms": "Terms",
      "beginDate": "Start",
      "closeDate": "End"
    },
    "keepForField": "Keep change history"
  }
}
